import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useExchangeAccessTokenMutation } from '../../services/canva';
import { useDispatchAlert } from '../../utils/customHooks';
import { AppCircularProgress } from '../../components/AppCircularProgress';
import { useEditImageHelper } from '../agrocraftArtisian/editImage/editImageHelper';
import { encrypted } from '../../utils/utility';

export const CanvaAuthRedirect = () => {
  const [searchParams] = useSearchParams();
  const dispatchAlert = useDispatchAlert();
  const { editImageAction, isEditImageActionLoading } =
    useEditImageHelper(true);

  const [exchangeAccessToken, { isLoading }] =
    useExchangeAccessTokenMutation();

  const exchangeAccessTokenApi = (
    authorizationCode: string
  ) => {
    exchangeAccessToken({ code: authorizationCode })
      .unwrap()
      .then(({ access_token }) => {        
        if (access_token) {
          const encryptedURL =
            localStorage.getItem('asset_url');
          const asset_url = encryptedURL
            ? encrypted.decrypt(encryptedURL)
            : null;
          if (asset_url) {
            editImageAction(access_token, asset_url);
          } else {
            dispatchAlert(
              'asset_url not found in loacal storage'
            );
          }
        } else {
          dispatchAlert(
            'access_token not present in exchangeAccessToken API response'
          );
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    const authorizationCode = searchParams.get('code');
    if (authorizationCode) {
      exchangeAccessTokenApi(authorizationCode);
    } else {
      dispatchAlert(
        'authorization code missing in canva redirect url'
      );
    }
  }, []);

  return (
    <>
      {(isLoading || isEditImageActionLoading) && (
        <AppCircularProgress />
      )}
    </>
  );
};
